<template>
  <div class="pe-options-grid">
    <div v-for="opt in question.optionGroups['radio'] || []" :key="opt.id" class="pe-option-item">
      <label class="pe-radio-label" @click.prevent="handleToggle(opt)">
        <input type="radio" :name="'question-' + opt.id" :checked="isChecked(opt)" class="pe-radio-input" @click.stop />
        <span :class="[globalConfig?.classes?.label]">{{ opt.title }}</span>
      </label>
    </div>
  </div>
</template>

<script setup>
import { inject } from 'vue';

const props = defineProps({
  question: { type: Object, required: true },
});

const engine = inject('formEngine');
const globalConfig = inject('engineConfig');

const isChecked = (opt) => {
  return opt.value !== null && opt.value !== undefined;
};

const handleToggle = (opt) => {
  if (isChecked(opt)) {
    engine.setAnswer(props.question.id, opt.id, null);
  } else {
    engine.setAnswer(props.question.id, opt.id, opt.title || 'Selected');
  }
};
</script>

<style scoped>
.pe-options-grid {
  display: grid;
  grid-template-columns: fit-content(50%) fit-content(50%);
  column-gap: var(--pe-radio-col-gap, 1.5vw); 
  row-gap: var(--pe-q-wrapper-gp, 1.5vh);
  justify-content: start; 
  width: 100%;
}

.pe-option-item:last-child:nth-child(odd) {
  /* Le decimos que empiece en la línea 1 y termine en la última (-1) */
  grid-column: 1 / -1; 
  /* Opcional: Si quieres que ocupe el 100% del ancho disponible */
  width: 100%; 
}

.pe-radio-label {
  display: flex;
  align-items: center;
  gap: var(--pe-radio-lbl-gp, 0.7rem);
  cursor: pointer;
  user-select: none;
  width: 100%;

  white-space: normal; 
  word-break: break-word;
}

.pe-radio-input {
  pointer-events: none;
  margin: 0;
  width: var(--pe-radio-size, 15px);
  aspect-ratio: 1/1;
  flex-shrink: 0;
}

@media (max-width: 600px) {
  .pe-options-grid {
    grid-template-columns: 1fr;
    /* Vuelve a 1 columna en móvil */
  }
}
</style>